import React from "react";
import "./style.css";
import ChallanGeneratedGraph from "./Common/ChallanGeneratedGraph";
import ChallaRequestReceived from "./Common/ChallanRequestReceived";
import FuelStatusGraph from "./Common/FuelStatusGraph";
import FuelConsumptionReport from "./Common/FuelConsumptionReport";
import DutyReports from "./Common/DutyReports";
import GoodsRequested from "./Common/GoodsRequested";
import InvoiceGeneratedGraph from "./Common/InvoiceGeneratedGraph";
import OBTS from "./Common/OBTS";
import WorkshopReport from "./Common/WorkshopReport";

function JorethangDashboard() {
  return (
    <>
      <div className="row m-0">
        <div className="col col-12 col-md-6 col-lg-6">
          <div className="graph-outline mb-3" style={{ height: "400px" }}>
            <WorkshopReport depo="40" />
          </div>
        </div>

        {/* Removed */}

        {/* <div className="col col-12 col-md-12 col-lg-6">
          <div className="graph-outline mb-3">
            <GoodsRequested depo="40" />
          </div>
        </div>
        <div className="col col-12 col-md-6 col-lg-6">
          <div className="graph-outline mb-3" style={{ height: "400px" }}>
            <ChallaRequestReceived depo="3" />
          </div>
        </div>
        <div className="col col-12 col-md-6 col-lg-6">
          <div className="graph-outline mb-3" style={{ height: "400px" }}>
            <FuelStatusGraph />
          </div>
        </div>
        <div className="col col-12 col-md-6 col-lg-6">
          <div className="graph-outline mb-3" style={{ height: "400px" }}>
            <FuelConsumptionReport />
          </div>
        </div>
        <div className="col col-12 col-md-6 col-lg-6">
          <div className="graph-outline mb-3" style={{ height: "400px" }}>
            <DutyReports depo="2" />
          </div>
        </div> */}
        {/* <div className="col col-12 col-md-6 col-lg-6">
          <div className="graph-outline mb-3">
            <OnlineTicketBookedCashCollected depo="40" />
          </div>
        </div> */}
        {/* <div className="col col-12 col-md-6 col-lg-6">
          <div className="graph-outline mb-3" style={{ height: "400px" }}>
            <InvoiceGeneratedGraph depo="40" />
          </div>
        </div> */}
        {/* <div className="col col-12 col-md-6 col-lg-6">
          <div className="graph-outline mb-3" style={{ height: "400px" }}>
            <OBTS depo="40" />
          </div>
        </div> */}
      </div>
    </>
  );
}

export default JorethangDashboard;
